import { joinURL } from 'ufo';

export const RESOLUTIONS = [360, 480, 768, 1080, 1440, 1920];

export default defineNuxtPlugin((nuxtApp) => {
  const {
    cloudinaryBaseUrl,
    cldn: { buckets },
  } = nuxtApp.$config.public;

  const cldn = {
    resolveBucketConfig(url) {
      const bucketConfig = buckets.find((bucket) => url.includes(bucket.uploadUrlPrefix));
      if (!bucketConfig) return null;

      bucketConfig.cloudinaryBaseUrl = cloudinaryBaseUrl;
      return bucketConfig;
    },

    focalPoint(url) {
      if (!url) return null;

      // extrats search query params and convert to object
      const result = (url.match(/([^#?]*)(\?[^#]*)?(#.*)?/) || []).splice(1);
      if (!result || !result[1]) return null;
      const params = Object.fromEntries(new URLSearchParams(result[1]));

      // uses v param
      const version = params.v;

      if (!version) return null;
      const parts = version.match(/^\d+,([0-9.]*),([0-9.]*)$/);
      if (parts === null) return null;
      if (parts.length !== 3) return null;
      const x = parseFloat(parts[1]) * 100;
      const y = parseFloat(parts[2]) * 100;
      return { x, y };
    },

    focalToGravity(x, y) {
      let vertical = 'center';
      if (y < 25) vertical = 'north';
      if (y > 75) vertical = 'south';

      let horizontal = 'center';
      if (x < 25) horizontal = 'west';
      if (x > 75) horizontal = 'east';

      if (vertical === 'center') return horizontal;
      if (horizontal === 'center') return vertical;
      return `${vertical}_${horizontal}`;
    },

    extractGravityFromUrl(url) {
      const focalPoint = this.focalPoint(url);

      if (focalPoint) {
        const { x, y } = focalPoint;
        return this.focalToGravity(x, y);
      }

      return null;
    },

    imgUrl(url) {
      const config = this.resolveBucketConfig(url);

      if (!config) {
        console.warn('cldn: image url could not be matched to bucket from cldn.buckets list', url);
        return null;
      }

      const path = url.split(config.uploadUrlPrefix)[1];

      return {
        path: joinURL(config.folder, path),
        provider: 'cloudinary',
      };
    },
  };

  return {
    provide: {
      cldn,
    },
  };
});
